import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

const Testimonials = () => {
  const [additionalTestimonials, setAdditionalTestimonials] = useState([]);

  useEffect(() => {
    fetch("/testimonios-aprobados.json")
      .then(res => res.ok ? res.json() : [])
      .then(data => setAdditionalTestimonials(Array.isArray(data) ? data : []))
      .catch(() => setAdditionalTestimonials([]));
  }, []);
  const courseCategories = [
    { id: 'all', name: 'Todos los cursos' },
    { id: 'doctorado', name: 'Doctorado Metafísica' },
    { id: 'hipnosis', name: 'Hipnosis' },
    { id: 'vision', name: 'Visión Áurica' },
    { id: 'reiki', name: 'Reiki' },
    { id: 'mejoras', name: 'Mejoras de vida en general' }
  ];

  // Datos personalizados de testimonios (índice = número de estudiante - 1)
  const customData = {
    1: {
      name: 'Veronica Leyva',
      country: 'Chile',
      course: 'Mejoras de vida en general',
      tags: ['mejoras'],
      description: 'He vivido un impacto transformador en la fundación desde 2019. Valoro muchísimo todos los talleres gratuitos y de pago que he tomado. El conocimiento recibido que me ha permitido encontrar "muchas verdades". La mejora en mi salud personal, mis relaciones familiares y con mi entorno. He vivido un "cambio total" en mi vida',
      videoUrl: 'https://player.vimeo.com/video/1042812570?h=9e29bb567e&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    2: {
      name: 'Alejandra',
      country: 'Argentina',
      course: 'Mejoras de vida en general',
      tags: ['mejoras'],
      description: 'Logré cambios significativos en mi vida, incluyendo sanar emocionalmente, mejorar mis relaciones interpersonales y descubrir mi deseo de ser madre que había estado postergando. Estas experiencias no solo me permitieron sanar internamente sino también ayudar a otras personas',
      videoUrl: 'https://player.vimeo.com/video/1042812494?h=574f4a9740&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    3: {
      name: 'Gabriela Carrizo',
      country: 'Argentina',
      course: 'Mejoras de vida en general',
      tags: ['mejoras'],
      description: 'He vivido una transformación profunda gracias a la Fundación Nueva Conciencia, destacando la accesibilidad y calidad de sus cursos, la facilidad para aprender terapias alternativas y el acompañamiento constante de sus docentes',
      videoUrl: 'https://player.vimeo.com/video/1042812800?h=a669b2551a&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    4: {
      name: 'Alumna Avanzada',
      country: 'México',
      course: 'Mejoras de vida en general',
      tags: ['mejoras'],
      description: 'Tras 18 meses de formación en la Fundación Nueva Conciencia, he vivido un cambio integral en múltiples dimensiones de mi ser en tres niveles principales: mi cuerpo físico y salud, mis emociones, y mi mente. No tengo palabras para agradecer tanto',
      videoUrl: 'https://player.vimeo.com/video/1087522770?h=dab7b9be97&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    5: {
      name: 'Libet Panfilo',
      country: 'México',
      course: 'Mejoras de vida en general',
      tags: ['mejoras'],
      description: 'Superé un cáncer en estadio 4 gracias a las enseñanzas y apoyo de la Fundación Nueva Conciencia. Mi gratitud eterna hacia el doctor Arenas y todo el equipo por las semillitas de conocimiento que sembraron en mí y que dieron como fruto mi recuperación total',
      videoUrl: 'https://player.vimeo.com/video/1087522696?h=38b1f376cd&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    6: {
      name: 'Alumna Avanzada',
      country: 'México',
      course: 'Mejoras de vida en general',
      tags: ['mejoras'],
      description: 'Agradezco profundamente a la Fundación Nueva Conciencia por dos años de enseñanzas que me han permitido sobrellevar problemas de salud y mejorar la convivencia con mi familia. Con ustedes he aprendido el "por qué" y el "para qué" de cada práctica, algo que no se encuentra en otros lugares, y mi mayor deseo es seguir recibiendo más cursos y actualizaciones',
      videoUrl: 'https://player.vimeo.com/video/1087522801?h=900648126a&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    7: {
      name: 'Alumna Avanzada',
      country: 'México',
      course: 'Mejoras de vida en general',
      tags: ['mejoras'],
      description: 'Agradezco profundamente a la Fundación Nueva Conciencia y al profesor Arenas por el acompañamiento recibido. Los cursos me han permitido comprender mejor mi entorno y potencial. Experimenté una sanación física e interior, adquiero cada día nuevos conocimientos y siento que mi vida ha cambiado de manera positiva, por lo que ahora aspiro a ayudar a los demás',
      videoUrl: 'https://player.vimeo.com/video/1087522824?h=20b2758421&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    8: {
      name: 'Gloria Mendoza',
      country: 'México',
      course: 'Mejoras de vida en general',
      tags: ['mejoras'],
      description: 'Agradezco con profundo sentimiento a todo el equipo de Fundación Nueva Conciencia — especialmente al Dr. Arenas, a los instructores y a los profesores — gracias por la "luz", sabiduría y amor recibidos. Esta experiencia me ha convertido en una mujer eficaz capaz de utilizar mis poderes humanos',
      videoUrl: 'https://player.vimeo.com/video/1042812677?h=8ceb3a80d3&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    9: {
      name: 'Veronica Rioja',
      country: 'México',
      course: 'Reiki',
      tags: ['reiki'],
      description: 'Conocí la Fundación en 2021 a través de un curso de Reiki Usui. Mi vida experimentó una transformación profunda que incluyó mejoras personales, en mis hijos y en mi práctica como psicóloga gracias a la aplicación de las técnicas aprendidas',
      videoUrl: 'https://player.vimeo.com/video/1042812600?h=458b50526a&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    10: {
      name: 'Alumna Avanzada',
      country: 'México',
      course: 'Mejoras de vida en general',
      tags: ['mejoras'],
      description: 'Mi profunda gratitud hacia la Fundación por la calidad humana de los maestros y por los conocimientos impartidos que me han permitido crecer física, moral y espiritualmente. Agradezco todos los obsequios y los cursos recibidos, son herramientas maravillosas para mi desarrollo personal',
      videoUrl: 'https://player.vimeo.com/video/1087522929?h=4af91094ad&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    11: {
      name: 'Alumna Avanzada',
      country: 'México',
      course: 'Mejoras de vida en general',
      tags: ['mejoras'],
      description: 'He vivido una transformación profunda y duradera: llevo siete años participando en los cursos gratuitos y de pago de la fundación y mi vida ha cambiado 200% gracias a esta formación. Esta experiencia no solo me ha permitido un desarrollo personal completo, sino que ahora estoy ayudando a otras personas, convirtiéndome en un multiplicador del conocimiento adquirido',
      videoUrl: 'https://player.vimeo.com/video/1087522957?h=3e744496ad&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    12: {
      name: 'Alumna Avanzada',
      country: 'México',
      course: 'Mejoras de vida en general',
      tags: ['mejoras'],
      description: 'Nuestro más profundo agradecimiento a Fundación Nueva Conciencia por haber transformado nuestras vidas: ahora gozamos de mejoras económicas, una relación familiar más unida y un crecimiento espiritual que nos permite valorar lo que antes pasaba desapercibido',
      videoUrl: 'https://player.vimeo.com/video/1087522985?h=84ae138bd0&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    13: {
      name: 'Claudia Estrada',
      country: 'México',
      course: 'Hipnosis, Reiki',
      tags: ['hipnosis', 'reiki'],
      description: 'Gracias a los diplomados de la Fundación Nueva Conciencia me certifiqué en hipnosis avanzada, reiki y magnetoterapia. Esto me permitió, en solo ocho meses, pasar de no tener nada a disponer de una consulta activa y una cartera de pacientes sólida. Además, me he liberado de la diabetes, el lupus y cargas emocionales intensas. Agradezco profundamente a los instructores Arenas y Miguel por la enseñanza y la paciencia brindada durante el proceso de aprendizaje',
      videoUrl: 'https://player.vimeo.com/video/1087523004?h=77c4b09167&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    14: {
      name: 'Alumna Avanzada',
      country: 'México',
      course: 'Mejoras de vida en general',
      tags: ['mejoras'],
      description: 'Ingresé a la Fundación hace poco más de dos años impulsada por la curiosidad que me despertó el término "Nueva Consciencia" y, desde entonces, he completado casi 50 cursos que me permitieron estabilizarme emocionalmente, abandonar analgésicos y seguir trabajando otras dolencias. Valoro muchísimo la formación de los docentes, todos con estudios de posgrado, y mi profunda gratitud por el cambio transformador que he experimentado gracias a la propuesta de la fundación',
      videoUrl: 'https://player.vimeo.com/video/1087523033?h=3663495009&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    15: {
      name: 'Alumna Avanzada',
      country: 'México',
      course: 'Mejoras de vida en general',
      tags: ['mejoras'],
      description: 'Agradezco a Fundación Nueva Conciencia por el despertar espiritual, físico y emocional que he experimentado gracias a sus enseñanzas',
      videoUrl: 'https://player.vimeo.com/video/1042812820?h=e72ee38d20&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    16: {
      name: 'Vero',
      country: 'Perú',
      course: 'Mejoras de vida en general',
      tags: ['mejoras'],
      description: 'En poco menos de un año en la Fundación Nueva Conciencia he logrado que mi familia pierda miedos y experimente abundancia plena. Agradezco profundamente al doctor Arenas por las enseñanzas y animo a otros a formarse porque el bienestar personal se refleja en el entorno cercano',
      videoUrl: 'https://player.vimeo.com/video/1087523061?h=ac49e4c842&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    17: {
      name: 'Alumna Avanzada',
      country: 'Colombia',
      course: 'Hipnosis',
      tags: ['hipnosis'],
      description: 'He logrado una transformación profunda de mi vida tras asistir a las conferencias, cursos y talleres de la Fundación. He logrado mejor control emocional, he aprendido sobre energías, salud y funcionamiento mental, y he dejado de repetir errores pasados. Utilizo activamente meditaciones, hipnosis, audios y hasta mascarillas, y valoro mucho el entorno "sano" y el "amor" que percibo en el equipo. Me siento una persona diferente internamente y ese cambio lo reflejo en mi desempeño diario',
      videoUrl: 'https://player.vimeo.com/video/1087523095?h=0e00dcfeb9&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    18: {
      name: 'Alumna Avanzada',
      country: 'México',
      course: 'Mejoras de vida en general',
      tags: ['mejoras'],
      description: 'Tras descubrir la Fundación hace casi 2 años, mi vida experimentó una transformación profunda: aprendí a vivir con mayor positividad y a disfrutar cada momento, sobre todo a superar la pérdida de mi marido que sucedió hace 4 años. Los cursos gratuitos y de pago que he compartido con mi hijo menor, quien padecía ansiedad, nos han permitido a ambos avanzar en nuestro bienestar emocional, logrando que mi hijo reduzca sus síntomas en aproximadamente un 90%',
      videoUrl: 'https://player.vimeo.com/video/1087523130?h=b5ff147ef7&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    19: {
      name: 'Maria Dolores Martinez',
      country: 'México',
      course: 'Mejoras de vida en general',
      tags: ['mejoras'],
      description: 'Atravesaba un abismo muy difícil y encontré en la Fundación Nueva Conciencia las herramientas que me cambiaron la vida. Agradezco con especial énfasis a mis instructores, a la Dra. Maura de la Cruz, a los doctores Arenas, Javier y Miguel, y a mi profesor favorito Walner por su acompañamiento y apoyo diario',
      videoUrl: 'https://player.vimeo.com/video/1042812507?h=bf94ab66c0&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    20: {
      name: 'Naraya Perez',
      country: 'Bolivia',
      course: 'Mejoras de vida en general',
      tags: ['mejoras'],
      description: 'Siento una profunda gratitud por el impacto transformador que ha tenido la fundación en mi vida. Las enseñanzas que he recibido han generado un cambio positivo permanente en mi vida y cada curso me proporciona exactamente el mensaje que necesito escuchar en cada momento de mi vida',
      videoUrl: 'https://player.vimeo.com/video/1087523227?h=92e35e0618&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    21: {
      name: 'Doralba Guadelo',
      country: 'Colombia',
      course: 'Mejoras de vida en general',
      tags: ['mejoras'],
      description: 'Llevo tres años con la Fundación Nueva Conciencia y acabo de renunciar a mi empleo para dedicarme por completo a la reflexología y otras terapias aprendidas en la institución. En solo quince días ya atiendo domicilios y estoy viviendo de lo que me gusta',
      videoUrl: 'https://player.vimeo.com/video/1087523287?h=556a0b8af5&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    22: {
      name: 'Alumna Avanzada',
      country: 'Argentina',
      course: 'Mejoras de vida en general',
      tags: ['mejoras'],
      description: 'Gracias a la Fundación Nueva Conciencia aprendí a amarme a mí misma. Eso me transformó la vida porque pasé de hacer lo que otros querían a pensar en mí y amarme primero. Cambié mi actitud de negativa a positiva y gracias a todos estos cambios hoy trabajo como terapeuta holística. Agradezco profundamente a los profesores y al Dr. Arenas por las enseñanzas',
      videoUrl: 'https://player.vimeo.com/video/1087523347?h=e66c096d50&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    23: {
      name: 'Margarita Vileno',
      country: 'Estados Unidos',
      course: 'Mejoras de vida en general',
      tags: ['mejoras'],
      description: 'Mi vida dio un giro completo tras sumarme a la Fundación Nueva Conciencia hace 3 años: gracias a las clases gratuitas y de pago, especialmente las del Dr. José Arenas, superé problemas de salud y altos niveles de estrés, dejé de depender de múltiples medicamentos, recuperé energía y ahora cuido activamente a mi nieta de tres años con un espíritu que se siente de quinceañera',
      videoUrl: 'https://player.vimeo.com/video/1087523496?h=abd48a3de9&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    24: {
      name: 'Carmen Gloria',
      country: 'Chile',
      course: 'Mejoras de vida en general',
      tags: ['mejoras'],
      description: 'Siento una profunda gratitud hacia la Fundación Nueva Conciencia por haberme abierto las puertas a un mundo desconocido que me ha llenado de espiritualidad y paz interior a través de los cursos gratuitos impartidos con amor y paciencia, así como de talleres de nivel avanzado que me han dado herramientas invaluables para mi vida cotidiana. Mi entorno cercano nota mi transformación personal y me comentan que "brillo" y estoy "distinta", y todo es gracias a los aprendizajes recibidos en la fundación',
      videoUrl: 'https://player.vimeo.com/video/1087523559?h=d7d129e3ec&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    25: {
      name: 'Alumna Avanzada',
      country: 'Venezuela',
      course: 'Mejoras de vida en general',
      tags: ['mejoras'],
      description: 'Mi madre falleció en el 2020 por COVID-19 y como los aeropuertos estaban cerrados no pude despedirla. Esto me sumió en una depresión profunda que empezó a revertirse el día que inicié con Fundación Nueva Consciencia, proceso que desde entonces me ha cambiado la forma de pensar y sentir gracias al acompañamiento de sus maestros. Ahora acepto que todo es trascendental y temporal, incorporando la energía como parte de mi vida, y reconozco que aunque aún me falta por aprender ya no me dejo arrastrar por las circunstancias como antes',
      videoUrl: 'https://player.vimeo.com/video/1087523603?h=e54c915827&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    26: {
      name: 'Jeannete Bravo',
      country: 'México',
      course: 'Mejoras de vida en general',
      tags: ['mejoras'],
      description: 'He sido alumna durante cuatro años de Fundación Nueva Conciencia, he logrado eliminar miedos, fobias y traumas no detectados previamente, y he mejorado significativamente mi vida personal, familiar y mi entorno diario',
      videoUrl: 'https://player.vimeo.com/video/1087521747?h=3a0749860b&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    27: {
      name: 'Jeannete Bravo',
      country: 'México',
      course: 'Hipnosis, Doctorado Metafísica',
      tags: ['hipnosis', 'doctorado'],
      description: 'Siento una profunda gratitud hacia la Fundación Nueva Conciencia y sus maestros por haberme proporcionado un camino de conocimiento que ya me ha permitido, tras cursar el diplomado en hipnosis, liberarme de bloqueos personales y ayudar a otros a superar miedos, fobias, traumas y problemas de peso, mientras continúo expandiendo mi formación estudiando el doctorado en Metafísica, un proceso que considero es una bendición',
      videoUrl: 'https://player.vimeo.com/video/1087521767?h=9b54b9fe4f&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    28: {
      name: 'Driana Pinto',
      country: 'Colombia',
      course: 'Reiki, Hipnosis',
      tags: ['reiki', 'hipnosis'],
      description: 'La fundación ofrece una amplia gama de cursos gratuitos y avanzados de Reiki, Usui, Tibetano, Arcangélico, todos impartidos por instructores de alto nivel que ayudan a los estudiantes a expandir su conocimiento y encontrar su verdadero ser interior. También imparten otras disciplinas como hipnosis, magnetoterapia y terapias adicionales, posicionándose como una de las principales fundaciones a nivel mundial en el campo de la sanación energética y el desarrollo personal',
      videoUrl: 'https://player.vimeo.com/video/1087521795?h=2fda324074&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    29: {
      name: 'Driana Pinto',
      country: 'Colombia',
      course: 'Reiki, Doctorado Metafísica, Hipnosis',
      tags: ['reiki', 'doctorado', 'hipnosis'],
      description: 'Tras estudiar reiki arcangélico, reiki usui, reiki tibetano y Metafísica con hipnosis, experimenté una transformación vital tan profunda que ahora me siento plenamente feliz',
      videoUrl: 'https://player.vimeo.com/video/1087521808?h=457abc86f5&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    30: {
      name: 'Joselyn Orendain',
      country: 'México',
      course: 'Reiki, Hipnosis, Visión Áurica, Doctorado Metafísica',
      tags: ['reiki', 'hipnosis', 'vision', 'doctorado'],
      description: 'Tras formarme en tres maestrías de Reiki, hipnosis y visión áurica, he conseguido sanar dolencias crónicas propias y de familiares, reducir la ansiedad y el alcoholismo de mi hermano mediante envío de Reiki a distancia y, tras tatuarme e incrustarme gemas, he armonizado mi vida, me he liberado de energías negativas y alcanzado una mayor paz interior',
      videoUrl: 'https://player.vimeo.com/video/1087521843?h=b1d01268ab&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    31: {
      name: 'Joselyn Orendain',
      country: 'México',
      course: 'Mejoras de vida en general',
      tags: ['mejoras'],
      description: 'He vivido una transformación profunda, superé la fibromialgia y dejé los medicamentos gracias a las enseñanzas de la Fundación, experimenté además una reducción del dolor en las hernias de disco que tenía, liberación de estrés y ansiedad, y un cambio hacia un estado emocional más alegre al aplicar las técnicas aprendidas',
      videoUrl: 'https://player.vimeo.com/video/1087521855?h=c5211fc644&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    32: {
      name: 'Ana Maria Bonzon',
      country: 'Argentina',
      course: 'Visión Áurica, Doctorado Metafísica, Reiki, Hipnosis',
      tags: ['vision', 'doctorado', 'reiki', 'hipnosis'],
      description: 'Desde hace cuatro años mi vida se transformó radicalmente gracias a los cursos gratuitos y de pago que tomé y sobre todo al doctorado online que curso actualmente, he logrado sobreponerme a la reciente pérdida de mi compañero de vida aplicando el conocimiento que he aprendido en la biblioteca de audios del doctor Arenas, y ahora transmito esas herramientas a mi familia, mi profunda gratitud al doctor Arenas y al cuerpo docente de la fundación',
      videoUrl: 'https://player.vimeo.com/video/1087521828?h=47f275e9cc&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    33: {
      name: 'Alumno Avanzado',
      country: 'México',
      course: 'Doctorado Metafísica',
      tags: ['doctorado'],
      description: 'Mi vida cambió radicalmente tras incorporar las técnicas de la Fundación Nueva Conciencia: pasé de vivir estresado por mi trabajo a sentirme feliz y energético gracias a las prácticas de relajación que aprendí. Mi transformación ha sido tan profunda que no solo mejoré mi desempeño laboral, sino que también me animé a cursar y completar exitosamente el doctorado en metafísica, una experiencia extraordinaria y altamente recomendable. El aplicar estas herramientas trae cambios positivos progresivos en salud, estado de ánimo y motivación, hasta el punto de sentirse "más contento, más lleno de energía". ¡Gracias!',
      videoUrl: 'https://player.vimeo.com/video/1087522118?h=a7696954a0&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    34: {
      name: 'Agustin Legarreta',
      country: 'México',
      course: 'Doctorado Metafísica',
      tags: ['doctorado'],
      description: 'Tras comenzar con los cursos gratuitos de Fundación Nueva Conciencia, sentí la necesidad de profundizar y ahora curso el Doctorado Digital en Metafísica, he completado ya 15 clases que han transformado mi vida, son tantas cosas maravillosas que es difícil ponerles palabras concretas; el acompañamiento de los maestros para resolver dudas es genial, el proceso de revisar cada lección varias veces hasta asimilarla y la emoción de avanzar, es una experiencia increíble, cualquiera con inquietudes sobre el ser debería emprender esta formación porque te permite crecer como persona, encontrar respuestas y realizar tus sueños',
      videoUrl: 'https://player.vimeo.com/video/1087522097?h=2bf5295bf4&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    35: {
      name: 'Karina Palma',
      country: 'Argentina',
      course: 'Doctorado Metafísica',
      tags: ['doctorado'],
      description: 'Me sentía vacía tras graduarme como Ingeniera Química y abandonar una maestría, encontré en el Doctorado en Metafísica de la Fundación Nueva Conciencia la vocación que mi alma pedía: ya tras once clases aplico las leyes universales aprendidas y mi vida ha girado 180° hacia el rumbo que soñaba, estoy feliz de haber descubierto este camino',
      videoUrl: 'https://player.vimeo.com/video/1087522070?h=fc19b552d3&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    36: {
      name: 'Rosa Lanis',
      country: 'México',
      course: 'Doctorado Metafísica',
      tags: ['doctorado'],
      description: 'Agradezco profundamente a la Fundación Nueva Consciencia y al Dr. Arenas por la transformación vital que he experimentado al cursar la clase 19 del doctorado, la sabiduría que he recibido ha sido "espectacular" y "mágica" para reconfigurar mi ser y mi entorno, y aunque algunas de las grabaciones anteriores quizá podrían estar ligeramente desactualizadas, cada enseñanza paso a paso permite comprenderla y guardarla "bien dentro en el corazón", soy completamente dichosa mientras disfruto cada paso del aprendizaje',
      videoUrl: 'https://player.vimeo.com/video/1087521967?h=64e79b5b34&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    37: {
      name: 'Jimena',
      country: 'Chile',
      course: 'Doctorado Metafísica',
      tags: ['doctorado'],
      description: 'Desde la primera clase del Doctorado Digital en Metafísica con el Doctor Arenas experimenté un cambio profundo que se expandió a mi familia, porque la metafísica no es solo teoría sino una transformación celular que redefine la forma de pensar, sentir y resolver problemas, recomiendo con entusiasmo asumirlo como una herramienta de vida',
      videoUrl: 'https://player.vimeo.com/video/1087522146?h=3b435951e0&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    38: {
      name: 'Miriam Santa Cruz',
      country: 'Ecuador',
      course: 'Doctorado Metafísica',
      tags: ['doctorado'],
      description: 'Gracias a esta institución he logrado lo que para mí son grandes objetivos en mi vida, recomiendo la fundación por sus instructores de excelente calidad y por el apoyo constante que brindan a los estudiantes',
      videoUrl: 'https://player.vimeo.com/video/1087521979?h=9f4b22c596&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    39: {
      name: 'Janeth Hernandez',
      country: 'Costa Rica',
      course: 'Doctorado Metafísica',
      tags: ['doctorado'],
      description: 'He vivido una transformación profunda gracias a la Fundación Nueva Conciencia. Después de más de 30 años de adicción al cigarrillo, logré dejarlo aplicando las estrategias del Capitán de su Alma y técnicas de alcalinidad y autohipnosis aprendidas en el doctorado de Metafísica. Además de superar el vicio, he mejorado mi salud mental reduciendo la ansiedad y el estrés, manifesté un vehículo propio a través de la ley de atracción intensificando mi deseo diariamente, y aplico todas las técnicas como limpieza de aura, imanes para manejar ambientes laborales difíciles',
      videoUrl: 'https://player.vimeo.com/video/1087521994?h=aa92e5e651&title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'
    }
  };

  // Generar testimonios con datos personalizados donde existan
  const testimonials = Array(39).fill(null).map((_, index) => {
    const studentNum = index + 1;
    const custom = customData[studentNum] || {};
    return {
      id: studentNum,
      name: custom.name || `Estudiante ${studentNum}`,
      country: custom.country || ['México', 'Colombia', 'Argentina', 'Chile', 'España', 'Perú'][index % 6],
      course: custom.course || 'Mejoras de vida en general',
      tags: custom.tags || ['mejoras'],
      description: custom.description || 'Este curso transformó mi vida de maneras que nunca imaginé posibles. La profundidad del conocimiento y la calidad de la enseñanza son excepcionales.',
      videoUrl: custom.videoUrl || 'https://www.youtube.com/embed/xa-IujFNRvE'
    };
  });

  const [selectedCategory, setSelectedCategory] = useState('all');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const allTestimonials = [...testimonials, ...additionalTestimonials];
  const filteredTestimonials = selectedCategory === 'all' 
    ? allTestimonials 
    : allTestimonials.filter(t => t.tags.includes(selectedCategory));

  return (
    <div className="min-h-screen bg-[#751fab]">
      {/* Hero Section */}
      <div className="container mx-auto px-4 py-12">
        <div className="text-center">
          <img 
            src="/logofncflor.png"
            alt="Nueva Consciencia Logo"
            className="w-[200px] h-[110px] mx-auto mb-8"
          />
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Testimonios de Nuestros Alumnos
          </h1>
          <p className="text-xl text-white mb-12 max-w-3xl mx-auto">
            Aquí encontrarás experiencias transformadoras de algunos de nuestros estudiantes.
            Cada historia es única y refleja el poder de nuestras enseñanzas.
          </p>

          {/* Category Selector */}
          <div className="relative max-w-md mx-auto mb-16">
            <button 
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="w-full bg-white text-[#751fab] px-6 py-3 rounded-lg shadow-lg flex items-center justify-between hover:bg-purple-50 transition-colors"
            >
              <span className="font-medium">
                {courseCategories.find(c => c.id === selectedCategory)?.name}
              </span>
              <ChevronDown className={`w-5 h-5 transform transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`} />
            </button>

            {isDropdownOpen && (
              <div className="absolute z-10 w-full mt-2 bg-white rounded-lg shadow-xl">
                {courseCategories.map((category) => (
                  <button
                    key={category.id}
                    onClick={() => {
                      setSelectedCategory(category.id);
                      setIsDropdownOpen(false);
                    }}
                    className={`w-full text-left px-6 py-3 hover:bg-purple-50 transition-colors ${
                      selectedCategory === category.id ? 'bg-purple-50 text-[#751fab]' : 'text-gray-700'
                    }`}
                  >
                    {category.name}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Testimonials Grid */}
      <div className="container mx-auto px-4 pb-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredTestimonials.map((testimonial) => (
            <div key={testimonial.id} className="bg-[#ad4bed] rounded-lg overflow-hidden shadow-lg">
              <div className="aspect-video">
                <iframe 
                  width="100%" 
                  height="100%" 
                  src={testimonial.videoUrl}
                  title={`Testimonio de ${testimonial.name}`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full h-full"
                ></iframe>
              </div>
              <div className="p-6">
                <h3 className="text-white font-bold text-xl mb-1">{testimonial.name}</h3>
                <p className="text-white/80 text-sm mb-1">{testimonial.country}</p>
                <p className="text-white/70 text-sm mb-3 italic">{testimonial.course}</p>
                <div className="bg-[#751fab] rounded p-3 mt-2">
                  <p className="text-white text-sm italic">"{testimonial.description}"</p>
                </div>
                <a 
                  href="https://fundacionnuevaconsciencia.com/thank_you/taranis/bienvenido-dr-taranis.php"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full mt-4 bg-white hover:bg-purple-100 text-[#751fab] font-bold py-3 px-6 rounded-lg text-center transition-colors shadow-lg"
                >
                  📲 Inscribirme curso gratis
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
